import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalQrisComponent } from '../modal-qris/modal-qris.component';
import { PAY_PACKAGE } from 'src/app/constants/endpoint.const';
import { Subject, takeUntil } from 'rxjs';
import { BaseService } from 'src/app/services/base.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  standalone: false,
  selector: 'app-modal-purchase',
  templateUrl: './modal-purchase.component.html',
  styleUrls: ['./modal-purchase.component.scss'],
})
export class ModalPurchaseComponent implements OnInit {
  destroy$ = new Subject();
  @Input() invoiceId: string = '';
  @Input() totalPrice: number = 0;
  @Input() packageId: number = 0;
  @Input() allowQris: boolean = true;
  selectedPayment: string = 'bank_transfer';
  @Input() qrCode: string = '';
  isQrCodeDisabled: boolean = false;
  qrDesc: string = 'No admin fee.';

  constructor(
    private route: Router,
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private BaseService: BaseService,
    private message: NzMessageService
  ) {}

  ngOnInit(): void {
    this.checkQrCodeDisabled();
  }

  checkQrCodeDisabled(): void {
    const currentDay = new Date().getDay();
    const today = new Date();

    const thursday = new Date(today);
    thursday.setDate(today.getDate() + (4 - today.getDay()));

    const saturday = new Date(today);
    saturday.setDate(today.getDate() + (6 - today.getDay()));

    const monthYearOptions: Intl.DateTimeFormatOptions = {
      month: 'long',
      year: 'numeric',
    };

    const dayOptions: Intl.DateTimeFormatOptions = {
      day: '2-digit',
    };

    if (currentDay === 4 || currentDay === 5 || currentDay === 6) {
      this.isQrCodeDisabled = true;

      const formattedDayStart = thursday.toLocaleDateString(
        'en-US',
        dayOptions
      );
      const formattedDayEnd = saturday.toLocaleDateString('en-US', dayOptions);
      const formattedMonthYear = thursday.toLocaleDateString(
        'en-US',
        monthYearOptions
      );

      this.qrDesc = `QRIS is disabled from ${formattedDayStart} - ${formattedDayEnd} ${formattedMonthYear}`;
    } else {
      this.isQrCodeDisabled = false;
      this.qrDesc = 'No admin fee.';
    }
  }

  destroyModal(): void {
    this.activeModal.close();
  }

  payNow(e: string) {
    const params = {
      payment_method: e,
      package_id: this.packageId,
    };

    if (e === 'qr_code' && this.isQrCodeDisabled) {
      this.message.create('error', "Can't use QRIS");
      return;
    }

    this.BaseService.postData(PAY_PACKAGE, params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (e === 'bank_transfer') {
            this.route.navigate(['subscriptions']);
            window.open(res.data.invoice_url, '_blank');
          } else {
            const modal = this.modalService.open(ModalQrisComponent, {
              size: 'md',
              backdrop: 'static',
              keyboard: false,
              centered: true,
            });

            Object.assign(modal.componentInstance, {
              invoiceId: this.invoiceId || res.data.invoice_id,
              allowQris: this.allowQris,
              packageId: this.packageId,
              expiredAt: res.data.expired_at,
              totalPrice: res.data.amount,
              qrCode: this.qrCode || res.data.qr_string,
            });
          }

          this.activeModal.close();
        },
        (err) => {
          this.message.create('error', err.data.errors);
        }
      );
  }

  back() {
    this.route.navigate(['subscriptions/upgrade-package']);
  }
}
